import { render, staticRenderFns } from "./FormLucus.vue?vue&type=template&id=505cb1cf&scoped=true"
import script from "./FormLucus.vue?vue&type=script&lang=ts"
export * from "./FormLucus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505cb1cf",
  null
  
)

export default component.exports